import { dataFetcher } from 'core/services/requestHandler';   

const getCommissionModelInfo = async (data = {}, config = {}) => {
  return dataFetcher('operations/commissionModelInfo', data, {...config});
};

const subscribeToCommissionModel = async (data = {}, config = {}) => {
  return dataFetcher('operations/subscribeToCommissionModel', data, {...config});
};

export {getCommissionModelInfo, subscribeToCommissionModel}
